import React, { useState } from "react";
import Icon from "assets/images/settings/secure.svg";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { object, string } from "yup";
import * as Yup from "yup";
import { useChangePassword } from "../../../services/mutations";
import { toast } from "react-toastify";
import TextView from "../../TextView";
import Input from "../../Input";
import {
  Error,
  Separator,
  StyledDialogActions,
  ResendButton,
} from "./styles";
import { PasswordValidation } from "./passwordValidation";
import Button from "../../Button";

const labelStyles = {
  fontSize: "16px",
  color: "#565556",
  lineHeight: "20px",
  fontFamily: "'DM Sans', sans-serif",
};

export const ChangePasswordContent = ({ onCancel, currentPassword }) => {
    
    const [password, setPassword] = useState("");

  const passwordSchema = object({
    new_password: string()
      .required("New Password is required")
      .min(8, "Password must be at least 8 characters")
      .max(20, "Password must be at most 20 characters")
      .matches(
        /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+|{}[\]:";'<>?,./])/,
        "Password must contain at least one uppercase letter, one numeric and one special character"
      ),
    confirm_new_password: string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("new_password"), null], "Passwords must match"),
  });

  const changePassword = useChangePassword();

  const onChangePassword = (values, { setSubmitting, resetForm }) => {
    changePassword.mutate(
      {
        old_password: currentPassword,
        password1: values.new_password,
        password2: values.confirm_new_password,
      },
      {
        onSuccess: (response) => {
          setSubmitting(false);
          toast.success("Password updated successfully!");
          resetForm();
          onCancel();
        },
        onError: (err) => {
          console.log(err);
          toast.error(err.response.data.message[0]);
          setSubmitting(false);
        },
      }
    );
  };

  return (
    <Formik
      initialValues={{
        new_password: "",
        confirm_new_password: "",
      }}
      validationSchema={passwordSchema}
      onSubmit={onChangePassword}
    >
      {({ isSubmitting, handleSubmit, isValid }) => (
        <Form>
          <div>
            <Field
              name="new_password"
              render={({ field }) => (
                <Input
                  {...field}
                  type="password"
                  label="New Password"
                  placeholder="New Password"
                  onChange={(e) => {
                    setPassword(e.target.value);
                    field.onChange(e);
                  }}
                  labelStyle={labelStyles}
                  style={{ maxWidth: 350 }}
                />
              )}
            />

            <PasswordValidation password={password}/>
          </div>
          <div className="mt-3">
            <Field
              name="confirm_new_password"
              render={({ field }) => (
                <Input
                  {...field}
                  type="password"
                  label="Confirm Password"
                  placeholder="Confirm Password"
                  labelStyle={labelStyles}
                  style={{ maxWidth: 350 }}
                />
              )}
            />
            <ErrorMessage name="confirm_new_password">
              {(msg) => <Error variant="tag">*{msg}</Error>}
            </ErrorMessage>
          </div>

          <Separator />

          <StyledDialogActions>
            <ResendButton onClick={onCancel}>Cancel</ResendButton>
            <Button type="submit" width={"auto"} disabled={!isValid}>Verify</Button>
          </StyledDialogActions>
        </Form>
      )}
    </Formik>
  );
};
